import { Coins, Flame, Star, Grid3x3, Wallet, ShoppingBasket, Volume2, VolumeX, Sparkles } from "lucide-react";

function Chip({ icon: Icon, color, label, value, tid, children }) {
  return (
    <div className="flex items-center gap-2 rounded-xl bg-black/45 backdrop-blur-md border border-white/10 px-3 py-1.5" data-testid={tid}>
      <Icon size={15} className={color} />
      <div className="leading-tight">
        <div className="font-pixel text-[7px] text-slate-300/80">{label}</div>
        <div className={`font-display font-black text-sm ${color}`}>{value}</div>
        {children}
      </div>
    </div>
  );
}

export const ValleyTopBar = ({ walletCro, state, onShop, claimer, sound, onToggleSound }) => {
  const span = Math.max(1, state.next_level_xp - state.level_xp);
  const pct = Math.min(100, ((state.xp - state.level_xp) / span) * 100);
  const unlockedCount = state.unlocked.filter(Boolean).length;
  return (
    <div className="absolute top-0 inset-x-0 p-2 sm:p-3 flex flex-wrap items-center gap-2 z-10" data-testid="valley-hud">
      <Chip icon={Wallet} color="text-sky-300" label="WALLET" value={`${walletCro} CRO`} tid="hud-wallet-cro" />
      <Chip icon={Coins} color="text-cyan-200" label="FARM" value={`${state.cro_balance.toFixed(2)} CRO`} tid="hud-farm-cro" />
      <Chip icon={Flame} color="text-orange-400" label="FLAME" value={state.flame.toLocaleString()} tid="hud-flame" />
      <Chip icon={Star} color="text-amber-300" label={`LV ${state.level}`} value={`${state.xp}/${state.next_level_xp} XP`} tid="hud-level">
        <div className="h-1 w-20 rounded bg-white/15 mt-0.5 overflow-hidden" data-testid="hud-xp-bar"><div className="h-full bg-amber-300" style={{ width: `${pct}%` }} /></div>
      </Chip>
      <Chip icon={Grid3x3} color="text-emerald-300" label="PLOTS" value={`${state.active_plots}/${unlockedCount}`} tid="hud-active-plots" />
      {state.yield_bonus_pct > 0 && <Chip icon={Sparkles} color="text-lime-300" label="BONUS" value={`+${state.yield_bonus_pct}%`} tid="hud-yield-bonus" />}
      <div className="flex-1" />
      <button data-testid="valley-sound-toggle" onClick={onToggleSound} className="rounded-xl bg-black/45 backdrop-blur-md border border-white/10 p-2 text-slate-200 hover:bg-black/60 transition-colors" aria-label="Toggle sound">
        {sound ? <Volume2 size={16} /> : <VolumeX size={16} />}
      </button>
      <button data-testid="valley-open-shop-button" onClick={onShop} className="btn-tactile btn-flame text-sm flex items-center gap-1.5 py-2"><ShoppingBasket size={15} /> Shop</button>
      <button data-testid="valley-topbar-claim-button" onClick={claimer.claim} disabled={claimer.disabled} className="btn-tactile btn-gold text-sm py-2">{claimer.label}</button>
    </div>
  );
};
